// NOMBASE — Persona resolution (brand-only MVP).
//
// Pre-Feb-2026 this module branched on five tenant_type values
// (brand, raw_ingredient_supplier, flavor_house, packaging_supplier,
// co_manufacturer) to decide which dashboard, sidebar, and route
// guards a user would see.
//
// The system is now brand-only — supplier/co-manufacturer/flavor-house
// surfaces have moved to separate apps. Every legitimate user of
// Nombase Connect is a brand. This module is preserved as a thin
// shim so consumers (AuthContext, AppShell, brand pages) keep
// importing the same names without churn — they just always get
// `isBrand: true` now.

/**
 * Resolve the effective tenant type. In the brand-only MVP this
 * always returns "brand".
 */
export function resolveEffectiveTenantType() {
  return 'brand';
}

/**
 * Resolve the persona flag bag. In the brand-only MVP `isBrand` is
 * always true; the legacy supplier/co-mfg flags are kept exported
 * as `false` constants so any stale callsites that still read them
 * fail closed (the supplier-only branch never runs).
 */
export function resolvePersonaFlags() {
  return {
    tenantType:          'brand',
    isBrand:             true,
    isSupplier:          false,
    isFlavorHouse:       false,
    isPackagingSupplier: false,
    isCoManufacturer:    false,
  };
}
